import * as TY from 'containers/pages/users/constants';

/**
 * @function convertExistList
 * @param { Array } contacts
 * @returns { Array } _contacts
 */
function convertExistList(contacts) {
	const _contacts = contacts.map((contact) => {
		let phone = null;
		let type = null;

		contact.dialCode === ''
			? (phone = contact.phoneWork + ' ' + contact.extension)
			: (phone = contact.dialCode + ' ' + contact.phoneWork + ' ' + contact.extension);

		contact.userId === '' ? (type = 'Contact') : (type = 'User');

		return {
			[TY.ID]: contact.contactId,
			[TY.USER_ID]: contact.userId,
			[TY.F_NAME]: contact.firstName,
			[TY.L_NAME]: contact.lastName,
			[TY.PHONE_WORK]: phone,
			[TY.EMAIL_WORK]: contact.emailWork,
			type: type,
		};
	});
	return _contacts;
}

export default convertExistList;
